import React, { useEffect, useRef, useState } from 'react';

interface PromptModalProps {
  title?: string;
  label?: string;
  placeholder?: string;
  initialValue?: string;
  required?: boolean;
  confirmText?: string;
  cancelText?: string;
  onSubmit: (value: string) => void;
  onCancel: () => void;
}

const PromptModal: React.FC<PromptModalProps> = ({
  title = 'Enter value',
  label,
  placeholder,
  initialValue = '',
  required = false,
  confirmText = 'OK',
  cancelText = 'Cancel',
  onSubmit,
  onCancel,
}) => {
  const [value, setValue] = useState(initialValue);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    // Autofocus the input when the dialog opens
    inputRef.current?.focus();
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (required && value.trim().length === 0) return;
    onSubmit(value);
  };

  return (
    <div className="modal-overlay" role="presentation" onClick={onCancel}>
      <div
        className="modal-content prompt-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="prompt-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <form onSubmit={handleSubmit}>
          <div className="modal-header">
            <h3 id="prompt-modal-title">{title}</h3>
            <button type="button" className="modal-close" onClick={onCancel}>
              &times;
            </button>
          </div>
          <div className="modal-body">
            {label && <label className="prompt-label">{label}</label>}
            <input
              ref={inputRef}
              type="text"
              className="prompt-input"
              value={value}
              placeholder={placeholder}
              onChange={(e) => setValue(e.target.value)}
            />
          </div>
          <div className="modal-footer">
            <button type="button" className="btn-cancel" onClick={onCancel}>
              {cancelText}
            </button>
            <button
              type="submit"
              className="btn-save"
              disabled={required && value.trim().length === 0}
            >
              {confirmText}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PromptModal;
